<ng-content select="campus-icon, [button-icon]"></ng-content>
@if (icon) {
  <dcr-icon class="campus-icon"
    [attr.icon]="icon"
    [class.rotate]="iconAnimation === 'rotate' && processing"
  ></dcr-icon>
}

@if (plainTooltip) {
  <campus-tooltip
    [plainTooltip]="plainTooltip"
    [tooltipDelay]="250"
    [anchor]="element"
    class="[ visually-hidden ]"
    >
  </campus-tooltip>
}

@if (badge) {
  <dcr-badge [count]="badge" class="[ absolute -top-2xs -right-2xs ]"></dcr-badge>
}

<dcr-state-layer class="bg-primary" [for]="element" type="circular"></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
